import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme, styled } from '../..'

// Component to surface in storybook
import Typestack from '.'
import readme from './readme.md'

// Story Setup
const stories = storiesOf('Digital-Commons/Typestack', module)

stories.addDecorator(withReadme(readme))

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

const Well = styled.div`
  background: #f3f3f3;
  padding: 20px;
  border-radius: 2px;
  margin-bottom: 30px;
`

// Stories
stories
  .add('Default', () => (
    <ThemeProvider theme={builtTheme}>
      <div>
        <p>Highlight:</p>

        <Well>
          <Typestack type='highlight'>Highlight</Typestack>
        </Well>

        <p>Headings XL</p>

        <Well>
          <Typestack type='heading' size='xl'>XL heading font weight default</Typestack>
          <Typestack type='heading' size='xl' weight='black'>XL heading font weight black</Typestack>
        </Well>

        <p>Headings LG</p>

        <Well>
          <Typestack type='heading' size='lg'>LG heading font weight default</Typestack>
          <Typestack type='heading' size='lg' weight='regular'>LG heading font weight regular</Typestack>
          <Typestack type='heading' size='lg' weight='black'>LG heading font weight black</Typestack>
        </Well>

        <p>Headings MD</p>

        <Well>
          <Typestack type='heading' size='md'>MD heading font weight default</Typestack>
          <Typestack type='heading' size='md' weight='regular'>MD heading font weight regular</Typestack>
          <Typestack type='heading' size='md' weight='black'>MD heading font weight black</Typestack>
        </Well>

        <p>Headings SM</p>

        <Well>
          <Typestack type='heading' size='sm'>SM heading font weight default</Typestack>
          <Typestack type='heading' size='sm' weight='black'>SM heading font weight black</Typestack>
        </Well>

        <p>Headings XS</p>

        <Well>
          <Typestack type='heading' size='xs'>XS heading font weight default</Typestack>
          <Typestack type='heading' size='xs' weight='black'>XS heading font weight black</Typestack>
        </Well>

        <p>Paragraphs</p>

        <Well>
          <Typestack type='paragraph' size='lg'>lg paragraph Lorem ipsum dolor sit amet, consectetur adipisicing elit. Delectus dolor fuga, libero magni modi non nulla perferendis quaerat reprehenderit ut. A eum iste minima placeat quibusdam quidem ullam, vero. Perspiciatis.</Typestack>
          <Typestack type='paragraph' size='md'>md paragraph Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam, commodi, corporis debitis enim eveniet exercitationem facere fugiat inventore iste laudantium molestiae neque, odit provident quibusdam quis tempore unde ut. Vel!</Typestack>
          <Typestack type='paragraph' size='sm'>sm paragraph Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias harum illum ipsam laudantium repellendus tempora tempore, vitae? Aliquid, asperiores aspernatur beatae dolor impedit iste quibusdam vel voluptatem? Commodi perspiciatis, reiciendis.</Typestack>
        </Well>

        <p>Eyebrow</p>

        <Well>
          <Typestack type='eyebrow'>Eyebrow</Typestack>
        </Well>
      </div>
    </ThemeProvider>
  ))
